<div
  class="smart-input-wrapper smart-input"
  [class.disabled]="disabled"
  [class.focused]="isFocused()"
  [class.has-icon]="icon"
  [class.icon-left]="icon && iconPosition === 'left'"
  [class.icon-right]="icon && iconPosition === 'right'"
  [style.width]="width"
  >

  @if (icon && iconPosition === 'left') {
    <ng-container *ngTemplateOutlet="iconControl"></ng-container>
  }

  <input
    #inputElement
    class="smart-input-field"
    [type]="type"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [readonly]="readonly"
    [attr.maxlength]="maxlength"
    [attr.minlength]="minlength"
    [autocomplete]="autocomplete"
    [value]="value()"
    (input)="onInputChange($event)"
    (keydown)="onKeydown($event)"
    (focus)="onFocus()"
    (blur)="onBlur()" />

  @if (icon && iconPosition === 'right') {
    <ng-container *ngTemplateOutlet="iconControl"></ng-container>
  }
</div>

<ng-template #iconControl>
  @if (iconIsLink) {
    <!-- mousedown neutralisé : sans ça le lien prend le focus et déclenche le blur de l'input juste
         avant son propre click. Le click, le ctrl+clic et le clic milieu, eux, restent intacts. -->
    <a
      class="custom-icon-button"
      [ngClass]="iconClass"
      [attr.href]="iconHref"
      [attr.target]="iconTarget"
      [attr.rel]="iconTarget === '_blank' ? 'noopener' : null"
      (mousedown)="$event.preventDefault()"
      (click)="onIconClick($event)"
      tabindex="-1">
      <ng-container *ngTemplateOutlet="iconGlyph"></ng-container>
    </a>
  } @else {
    <button
      type="button"
      class="custom-icon-button"
      [ngClass]="iconClass"
      [disabled]="disabled"
      (click)="onIconClick($event)"
      tabindex="-1">
      <ng-container *ngTemplateOutlet="iconGlyph"></ng-container>
    </button>
  }
</ng-template>

<ng-template #iconGlyph>
  @if (iconType === 'material') {
    <mat-icon>{{ icon }}</mat-icon>
  } @else {
    <svg viewBox="0 0 24 24">
      <path [attr.d]="icon" fill="currentColor"/>
    </svg>
  }
</ng-template>
